import React, { useState } from 'react'
import { useSnackbar } from 'notistack'

import { notifOps, usePet } from '../../modules'
import Modal from '../resusable/modal'

const Elevated = ({ visible, toggle, onSuccess }) => {
    const [uname, setUname] = useState('')
    const [pwd, setPwd] = useState('')
    
    const { enqueueSnackbar } = useSnackbar()

    const onComplete = ({ data }, notif) => {
        notif('Admin verified', notifOps('success'))
        onSuccess?.fn()
        onSuccess?.setToken(data.token)
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('userLogin', {
        username: uname, 
        password: pwd,
        app: 'elevated'
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Just a minute...' } })

    const enableUname = uname?.trim().length > 3
    const enablePwd = pwd?.trim().length > 3

    const performLogin = () => {
        if (!enableUname)
            enqueueSnackbar('Please enter a correct format for username', notifOps('warning'))

        if (!enablePwd)
            enqueueSnackbar('Please enter a correct format for password', notifOps('warning'))

        if (enableUname && enablePwd)
            execute()
    }

    const onKeyUp = e => {
        if (e.keyCode === 13)
            performLogin()
    }

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Admin Login Required"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Username
                    </label>
                    <input
                        onKeyUp={ onKeyUp }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-user-name"
                        type="text"
                        onChange={ e => setUname(e.target.value) }
                        placeholder="Username" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Password
                    </label>
                    <input
                        onKeyUp={ onKeyUp }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-password"
                        type="password"
                        onChange={ e => setPwd(e.target.value) }
                        placeholder="*********" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ performLogin } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Log In</button>
            </div>
        </Modal>
    )
}

export default Elevated